import "whatwg-fetch";
//import Error from "./Error.js";
import ActionParams from "./ActionParams.tsx";
import ResponseData from "./ResponseData.ts";

const Action = {
    fetchJson(
        path: string,
        method: string,
        header: Headers,
        body: BodyInit | null = null,
        callbackHandler: Function | null = null,
        errorHandler: Function | null = null
    ) {
        fetch(ActionParams.PATH + path, {
            method: method,
            headers: header,
            body: (method === "POST" || method === "PATCH") && body ? body : null,
        })
            .then(async (response) => {
                if (response.status === 200) {
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return response.json();
                    } else {
                        return { error: response.status };
                    }
                } else if (response.status === 400) {
                    return { error: 400 };
                } else if (response.status === 401) {
                    return { error: 401 };
                } else if (response.status === 403) {
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return { error: 1, data: response.json() };
                    } else {
                        return { error: response.status };
                    }
                } else {
                    return { error: 0 };
                }
            })
            .then(function (data) {
                const response_data = new ResponseData();

                if (data && !data.error && callbackHandler) {
                    response_data.data = data;

                    callbackHandler(response_data);
                } else {
                    if (data && data.error === 1) {
                        //message有の場合
                        data.data.then(function (error) {
                            if (errorHandler) errorHandler(error);
                        });
                    } else if (errorHandler) {
                        errorHandler(data);
                    }
                }
            });
    },

    fetchAuthorizedJson(
        path: string,
        token: string,
        method: string,
        header: Headers,
        body: BodyInit | null = null,
        callbackHandler: Function | null = null,
        errorHandler: Function | null = null
    ) {
        if (!token) {
            return false;
        }

        header.set("Authorization", "Bearer " + token);

        fetch(ActionParams.PATH + path, {
            method: method,
            headers: header,
            body: body ? body : null,
        })
            .then(async (response) => {
                if (response.status === 200) {
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return {
                            body: response.json(),
                            headers: response.headers,
                        };
                    } else {
                        return { error: response.status };
                    }
                } else if (response.status === 401) {
                    return { error: 401 };
                } else if (response.status === 403) {
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return { error: 1, data: response.json() };
                    } else {
                        return { error: response.status };
                    }
                } else {
                    return { error: response.status };
                }
            })
            .then(function (data) {
                if (data && !data.error && callbackHandler) {
                    const response_data = new ResponseData();
                    response_data.data = data.body;

                    callbackHandler(response_data);
                    //response_data.headers = data.headers;
                } else {
                    if (errorHandler) {
                        errorHandler(data);
                    } else {
                        console.log("error");
                    }
                }
            });
    },

    fetchPublicJson(path, method, header, body = null, callbackHandler = null, errorHandler = null) {
        fetch(ActionParams.PUBLIC_PATH + path, {
            method: method,
            headers: header,
            body: (method === "POST" || method === "PATCH") && body ? body : null,
        })
            .then(async (response) => {
                if (response.status === 200) {
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return response.json();
                    } else {
                        return { error: response.status };
                    }
                } else if (response.status === 400) {
                    return { error: 400 };
                } else if (response.status === 401) {
                    return { error: 401 };
                } else if (response.status === 403) {
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return { error: 1, data: response.json() };
                    } else {
                        return { error: response.status };
                    }
                } else {
                    return { error: 0 };
                }
            })
            .then(function (data) {
                if (data && !data.error && callbackHandler) {
                    callbackHandler(data);
                } else {
                    if (data && data.error === 1) {
                        data.then(function (error) {
                            errorHandler(error);
                        });
                    } else if (errorHandler) {
                        errorHandler(data);
                    }
                }
            });
    },
};

export default Action;
